module.exports = __webpack_public_path__ + "img/warning-sign.ac0b01c0.jpg";